import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import { getProducts } from "../../actions/products/products";
import {
  getRentals,
  getRentalsAdmin,
  getRentalsSales,
  updateRentalStatus,
  createDmRentals,
  searchEquipmentsByRef,
  updateRentalResident,
  updateRentalInternalRef,
} from "../../actions/rentals/rentals";
import APIUrl from "../../APIUrl";
import Roles from "../../enums/Roles";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { NotificationManager } from "react-notifications";
import { addBrand } from "../../actions/configurables/brands";
import { addModel } from "../../actions/configurables/models";
import { addMaterialsType } from "../../actions/settings/materialsTypes/materialsTypes";
import "react-notifications/lib/notifications.css";
import "../../css/rentals/rentals.css";
import RentalDateModal from "./RentalDateModal";
import RentalDeleteModal from "./RentalDeleteModal";
import RentalExtendModal from "./RentalExtendModal";
import RentalTerminateModal from "./RentalTerminateModal";
import RentalValidationModal from "./RentalValidationModal";
import RentalSyncModal from "./RentalSyncModal";
import RentalRequestEndModal from "./RentalRequestEndModal";
import RentalCancelEndRequestModal from "./RentalCancelEndRequestModal";
import RentalDeliveryConfirmModal from "./RentalDeliveryConfirmModal";
import RentalRecoveryConfirmModal from "./RentalRecoveryConfirmModal";
import RentalReadyToDeliverModal from "./RentalReadyToDeliverModal";
import RentalSetToPreparationModal from "./RentalSetToPreparationModal";
import RentalFamiliesTab from "./RentalFamiliesTab";
import RentalTabContent from "./RentalTabContent";
import RentalResidentModal from "./RentalResidentModal";
import RentalInternalRefModal from "./RentalInternalRefModal";
import RentalPriceModal from "./RentalPriceModal";
import { getResidents, getAllResidents, addResident, addResidentAdmin } from "../../actions/residents/residents";
import { getEstablishments } from "../../actions/establishments/establishments";
import * as RentalUtils from "../../util/RentalUtils";
import * as DmSyncHelper from "../../util/RentalDmSyncHelper";

class Rentals extends React.Component {
  constructor(props) {
    super(props);

    const now = new Date();

    // Déterminer l'onglet initial en fonction de l'URL
    // L'application utilise HashRouter, donc le chemin est dans window.location.hash
    const hash = window.location.hash;
    const path = hash.split("?")[0]; // Récupérer la partie avant les paramètres
    const urlParams = new URLSearchParams(hash.split("?")[1]);
    const rentalId = urlParams.get("rentalId");

    let initialTab;
    if (rentalId || path.includes("/rentals/active-rentals")) {
      initialTab = "rentals";
    } else if (path.includes("/rentals/families")) {
      initialTab = "families";
    } else {
      // Pour les clients, garder le système d'onglets, pour les admins/sales rep afficher direct les locations
      initialTab =
        this.props.user.role === Roles.ADMIN ||
        this.props.user.role === Roles.SALES_REP
          ? "rentals"
          : "families";
    }

    this.state = {
      activeTab: initialTab, // "families" or "rentals"
      searchTerm: "",
      filteredFamilies: [],
      selectedMonth: now.getMonth() + 1, // 1-12
      selectedYear: now.getFullYear(),
      selectedStatus: "all", // "all", "en_attente", "actif", "termine"
      selectedEstablishment: "all", // "all" ou l'ID d'un établissement
      expandedSections: {
        starts: true,
        ongoing: true,
        ends: true,
        upcoming: true,
      },
      lightboxOpen: false,
      lightboxImage: null,
      openDropdowns: {}, // Pour gérer l'état des dropdowns
      dropdownDirections: {}, // Pour gérer la direction d'ouverture des dropdowns (up/down)
      // État pour le modal de date
      showDateModal: false,
      selectedRental: null,
      selectedStartDate: "",
      selectedEndDate: "",
      isLoading: false,
      // État pour le modal de suppression
      showDeleteModal: false,
      selectedRentalForDelete: null,
      deletionReason: "",
      // État pour le modal de validation de location
      showValidationModal: false,
      selectedRentalForValidation: null,
      selectedEquipment: null,
      selectedEquipmentOption: null,
      selectedEquipmentState: "",
      selectedMaterialType: "",
      selectedBrand: "",
      selectedModel: "",
      validationLoading: false,
      validationRefInterne: "",
      equipmentSearchResults: [],
      isSearchingEquipments: false,
      confirmReassignment: false,
      disinfectionDate: "",
      // État pour le modal de synchronisation DM
      showSyncModal: false,
      dmList: [],
      loadingDmList: false,
      selectedDmIds: [],
      selectAllDm: false,
      establishmentFilter: "",
      dmSearchTerm: "",
      syncStep: 1, // 1: Selection, 2: Dates and prices
      dmRentalData: {}, // {dmId: {startDate: "", endDate: "", dailyPrice: ""}}
      globalStartDate: "", // Date de début globale pour tous les DM
      globalDailyPrice: "", // Prix journalier global pour tous les DM
      // État pour le modal de prolongation de location
      showExtendModal: false,
      selectedRentalForExtend: null,
      extendEndDate: "",
      extendLoading: false,
      // État pour le modal de terminaison de location
      showTerminateModal: false,
      selectedRentalForTerminate: null,
      terminateLoading: false,
      // État pour le modal de demande de fin de location (client uniquement)
      showRequestEndModal: false,
      selectedRentalForRequestEnd: null,
      requestEndLoading: false,
      // État pour le modal d'annulation de demande de fin (client uniquement)
      showCancelEndRequestModal: false,
      selectedRentalForCancelEnd: null,
      cancelEndLoading: false,
      // État pour le modal de confirmation de livraison
      showDeliveryConfirmModal: false,
      selectedRentalForDelivery: null,
      deliveryConfirmLoading: false,
      // État pour le modal de confirmation de récupération
      showRecoveryConfirmModal: false,
      selectedRentalForRecovery: null,
      recoveryConfirmLoading: false,
      // État pour le modal de confirmation "à livrer" (depuis EN_PREPARATION)
      showReadyToDeliverModal: false,
      selectedRentalForReadyToDeliver: null,
      readyToDeliverLoading: false,
      // État pour le modal de confirmation "en préparation" (depuis EN_ATTENTE)
      showSetToPreparationModal: false,
      selectedRentalForPreparation: null,
      setToPreparationLoading: false,
      // État pour le modal de modification du résident
      showResidentModal: false,
      selectedRentalForResident: null,
      residentModalLoading: false,
      // État pour le modal de modification de la référence interne
      showInternalRefModal: false,
      selectedRentalForInternalRef: null,
      internalRefModalLoading: false,
      // État pour le modal de modification du prix journalier
      showPriceModal: false,
      selectedRentalForPrice: null,
      priceModalLoading: false,
    };
  }

  componentDidMount() {
    // Scroll vers le haut de la page
    window.scrollTo(0, 0);

    this.props.onGetProducts();

    // Attendre que l'utilisateur soit chargé avant de faire l'appel
    if (this.props.user && this.props.user.role !== undefined) {
      this.fetchRentalsBasedOnRole();
      this.fetchResidentsBasedOnRole();
      // Charger les établissements pour les admins/sales rep
      if (this.props.user.role === Roles.ADMIN || this.props.user.role === Roles.SALES_REP) {
        this.props.onGetEstablishments();
      }
    }

    // Ajouter un listener pour fermer les dropdowns quand on clique ailleurs
    document.addEventListener("click", this.closeAllDropdowns);
  }

  componentDidUpdate(prevProps) {
    // Si l'utilisateur vient d'être chargé, faire l'appel approprié
    if (
      prevProps.user?.role !== this.props.user?.role &&
      this.props.user?.role !== undefined
    ) {
      this.fetchRentalsBasedOnRole();
      // Charger les établissements pour les admins/sales rep
      if (this.props.user.role === Roles.ADMIN || this.props.user.role === Roles.SALES_REP) {
        this.props.onGetEstablishments();
      }
    }
    if (prevProps.products !== this.props.products) {
      this.filterRentalFamilies();
    }

    // Synchroniser l'onglet avec l'URL si elle change
    if (prevProps.location?.pathname !== this.props.location?.pathname) {
      const hash = window.location.hash;
      const path = hash.split("?")[0];
      const urlParams = new URLSearchParams(hash.split("?")[1]);
      const rentalId = urlParams.get("rentalId");

      let newTab;
      if (rentalId || path.includes("/rentals/active-rentals")) {
        newTab = "rentals";
      } else if (path.includes("/rentals/families")) {
        newTab = "families";
      }

      if (newTab && newTab !== this.state.activeTab) {
        this.setState({ activeTab: newTab });
      }
    }
  }

  fetchRentalsBasedOnRole = () => {
    if (this.props.user.role === Roles.ADMIN) {
      return this.props.onGetRentalsAdmin();
    } else if (this.props.user.role === Roles.SALES_REP) {
      return this.props.onGetRentalsSales();
    } else {
      return this.props.onGetRentals();
    }
  };

  fetchResidentsBasedOnRole = () => {
    if (
      this.props.user.role === Roles.ADMIN ||
      this.props.user.role === Roles.SALES_REP
    ) {
      return this.props.onGetAllResidents();
    } else {
      return this.props.onGetResidents();
    }
  };

  componentWillUnmount() {
    document.removeEventListener("click", this.closeAllDropdowns);
  }

  filterRentalFamilies = () => {
    const rentalProducts = this.props.products.filter(
      (product) =>
        product.famille && product.famille.toLowerCase().includes("location"),
    );

    const familiesMap = new Map();

    rentalProducts.forEach((product) => {
      if (product.famille) {
        // Utiliser uniquement le nom de famille comme clé pour regrouper tous les produits ensemble
        const familyKey = product.famille;

        if (!familiesMap.has(familyKey)) {
          familiesMap.set(familyKey, {
            famille: product.famille,
            fam: product.fam,
            mercurial_id: product.mercurial_id,
            products: [],
          });
        }
        familiesMap.get(familyKey).products.push(product);
      }
    });

    const families = Array.from(familiesMap.values()).sort((a, b) =>
      a.famille.localeCompare(b.famille),
    );

    const filteredFamilies = this.state.searchTerm
      ? families.filter((family) =>
          family.famille
            .toLowerCase()
            .includes(this.state.searchTerm.toLowerCase()),
        )
      : families;

    this.setState({ filteredFamilies });
  };

  handleSearchChange = (e) => {
    const searchTerm = e.target.value;
    this.setState({ searchTerm }, () => this.filterRentalFamilies());
  };

  handleProductSelected = (product) => {
    if (product) {
      // Rediriger vers la page du produit spécifique avec scroll automatique
      if (product.mercurial_id && product.famille) {
        // Encode la famille pour l'URL et ajoute l'ID du produit
        const encodedFamille = encodeURIComponent(product.famille);
        // Utiliser le _id du produit pour permettre au composant RentalProducts de faire le scroll
        const productPath = `/home/rentals/mercurial/${product.mercurial_id}/${encodedFamille}/${product._id}?from=rentals`;
        // Scroll vers le haut avant la navigation
        window.scrollTo(0, 0);
        // Utiliser replace au lieu de push pour éviter des problèmes d'historique
        this.props.history.push(productPath);
      }
    }
  };

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab, searchTerm: "" });

    // Mettre à jour l'URL en fonction de l'onglet sélectionné
    const newPath =
      tab === "families"
        ? "/home/rentals/families"
        : "/home/rentals/active-rentals";

    this.props.history.push(newPath);
  };

  handleMonthChange = (e) => {
    this.setState({ selectedMonth: parseInt(e.target.value) });
  };

  handleYearChange = (e) => {
    this.setState({ selectedYear: parseInt(e.target.value) });
  };

  handleStatusChange = (e) => {
    this.setState({ selectedStatus: e.target.value });
  };

  handleEstablishmentChange = (e) => {
    this.setState({ selectedEstablishment: e.target.value });
  };

  toggleSection = (section) => {
    this.setState((prevState) => ({
      expandedSections: {
        ...prevState.expandedSections,
        [section]: !prevState.expandedSections[section],
      },
    }));
  };

  toggleDropdown = (rentalIndex, sectionKey, event) => {
    const dropdownId = `${sectionKey}-${rentalIndex}`;
    const isCurrentlyOpen = this.state.openDropdowns[dropdownId];

    if (!isCurrentlyOpen && event) {
      // Calculer si on doit ouvrir vers le haut ou vers le bas
      const button = event.currentTarget;
      const rect = button.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const dropdownHeight = 300; // Estimation de la hauteur max du dropdown

      // Si pas assez d'espace en dessous, ouvrir vers le haut
      const openUpward =
        spaceBelow < dropdownHeight && rect.top > dropdownHeight;

      // Fermer tous les dropdowns et ouvrir celui-ci
      this.setState({
        openDropdowns: {
          [dropdownId]: true,
        },
        dropdownDirections: {
          [dropdownId]: openUpward ? "up" : "down",
        },
      });
    } else {
      // Fermer tous les dropdowns
      this.setState({
        openDropdowns: {},
        dropdownDirections: {},
      });
    }
  };

  closeAllDropdowns = () => {
    this.setState({ openDropdowns: {} });
  };

  // Wrappers pour les fonctions utilitaires (permet de passer this.state.selectedMonth/Year)
  filterRentalsByCategory = (rentals) => {
    return RentalUtils.filterRentalsByCategory(
      rentals,
      this.state.selectedMonth,
      this.state.selectedYear,
    );
  };

  calculateMonthlyPrice = (rental) => {
    return RentalUtils.calculateMonthlyPrice(
      rental,
      this.state.selectedMonth,
      this.state.selectedYear,
    );
  };

  calculateSectionTotal = (rentals) => {
    return RentalUtils.calculateSectionTotal(
      rentals,
      this.state.selectedMonth,
      this.state.selectedYear,
    );
  };

  formatPrice = (price) => {
    return RentalUtils.formatPrice(price);
  };

  formatStatus = (status) => {
    return RentalUtils.formatStatus(status);
  };

  // Ouvrir le modal pour modifier les dates
  openDateModal = (rental) => {
    const defaultStartDate = rental.start_date
      ? new Date(rental.start_date).toISOString().split("T")[0]
      : new Date().toISOString().split("T")[0];
    const defaultEndDate = rental.end_date
      ? new Date(rental.end_date).toISOString().split("T")[0]
      : "";

    this.setState({
      showDateModal: true,
      selectedRental: rental,
      selectedStartDate: defaultStartDate,
      selectedEndDate: defaultEndDate,
      isLoading: false,
    });
  };

  // Fermer le modal
  closeDateModal = () => {
    this.setState({
      showDateModal: false,
      selectedRental: null,
      selectedStartDate: "",
      selectedEndDate: "",
      isLoading: false,
    });
  };

  // Gérer le changement de date de début
  handleStartDateChange = (event) => {
    this.setState({ selectedStartDate: event.target.value });
  };

  // Gérer le changement de date de fin
  handleEndDateChange = (event) => {
    this.setState({ selectedEndDate: event.target.value });
  };

  // Confirmer la modification de date
  confirmDateAction = () => {
    const { selectedRental, selectedStartDate, selectedEndDate } = this.state;

    // Validation de la date de début (obligatoire)
    if (!selectedStartDate) {
      this.showErrorNotification("Veuillez sélectionner une date de début");
      return;
    }

    // Vérifier que la date de début est avant la date de fin (seulement si date de fin est renseignée)
    if (selectedEndDate) {
      const startDate = new Date(selectedStartDate);
      const endDate = new Date(selectedEndDate);

      if (startDate >= endDate) {
        this.showErrorNotification(
          "La date de début doit être avant la date de fin",
        );
        return;
      }
    }

    this.setState({ isLoading: true });

    // Utiliser le nouvel endpoint spécifique pour modifier la date
    const endpoint = `${APIUrl.rootUrl}/rental/${selectedRental._id}/update-date`;
    const token = APIUrl.jwtToken || sessionStorage.getItem("jwtToken");

    // Préparer le corps de la requête
    const requestBody = {
      start_date: selectedStartDate,
    };

    // N'ajouter end_date que si elle est renseignée
    if (selectedEndDate) {
      requestBody.end_date = selectedEndDate;
    }

    fetch(endpoint, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        jwtToken: token,
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => {
        if (response.ok) {
          this.showSuccessNotification(
            "Les dates ont été modifiées avec succès !",
          );
          this.fetchRentalsBasedOnRole(); // Refresh data based on role
          this.closeDateModal();
        } else {
          this.showErrorNotification(
            "Erreur lors de la modification des dates",
          );
          this.setState({ isLoading: false });
        }
      })
      .catch((error) => {
        this.showErrorNotification("Erreur lors de la modification des dates");
        this.setState({ isLoading: false });
      });
  };

  // Afficher une notification de succès
  showSuccessNotification = (message) => {
    NotificationManager.success(message, "Succès", 4000);
  };

  // Afficher une notification d'erreur
  showErrorNotification = (message) => {
    NotificationManager.error(message, "Erreur", 4000);
  };

  // Handle modifying rental end date - Ouvre le modal approprié selon le rôle et le statut
  handleModifyRental = (rental) => {
    const isAdmin = this.props.user.role === Roles.ADMIN || this.props.user.role === Roles.SALES_REP;
    const RentalStatus = require("../../enums/RentalStatus").default;

    // Pour les locations ACTIF : admins modifient, clients demandent la fin
    if (rental.status === RentalStatus.ACTIF) {
      if (isAdmin) {
        this.openDateModal(rental);
      } else {
        this.openRequestEndModal(rental);
      }
    } else {
      // Pour EN_ATTENTE et A_LIVRER : tout le monde peut modifier les dates
      this.openDateModal(rental);
    }
  };

  // Ouvrir le modal de suppression
  openDeleteModal = (rental) => {
    this.setState({
      showDeleteModal: true,
      selectedRentalForDelete: rental,
      deletionReason: "",
      isLoading: false,
    });
  };

  // Fermer le modal de suppression
  closeDeleteModal = () => {
    this.setState({
      showDeleteModal: false,
      selectedRentalForDelete: null,
      deletionReason: "",
      isLoading: false,
    });
  };

  // Gérer le changement de la raison de suppression
  handleDeletionReasonChange = (e) => {
    this.setState({ deletionReason: e.target.value });
  };

  // Confirmer la suppression de la location
  confirmDeletion = async () => {
    const { selectedRentalForDelete, deletionReason } = this.state;

    if (!selectedRentalForDelete) {
      return;
    }

    const RentalStatus = require("../../enums/RentalStatus").default;
    const isEnAttente = selectedRentalForDelete.status === RentalStatus.EN_ATTENTE;

    // Vérifier que la raison est renseignée uniquement pour EN_ATTENTE
    if (isEnAttente && (!deletionReason || deletionReason.trim() === "")) {
      this.showErrorNotification("La raison de suppression est obligatoire");
      return;
    }

    this.setState({ isLoading: true });

    const endpoint = `${APIUrl.rootUrl}/rental/${selectedRentalForDelete._id}`;
    const token = APIUrl.jwtToken || sessionStorage.getItem("jwtToken");

    try {
      const response = await fetch(endpoint, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          jwtToken: token,
        },
        body: JSON.stringify({
          reason: isEnAttente ? deletionReason.trim() : "",
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data && data.success) {
        this.setState({ isLoading: false });

        const message = "Location supprimée avec succès !";
        this.showSuccessNotification(message);

        // Refresh data
        if (this.props.user.role === Roles.ADMIN) {
          await this.props.onGetRentalsAdmin();
        } else if (this.props.user.role === Roles.SALES_REP) {
          await this.props.onGetRentalsSales();
        } else {
          await this.props.onGetRentals();
        }

        this.closeDeleteModal();
      } else {
        throw new Error(data.error || "Erreur lors de la suppression");
      }
    } catch (error) {
      this.showErrorNotification(
        "Erreur lors de la suppression de la location",
      );
      this.setState({ isLoading: false });
    }
  };

  // Méthodes pour le modal de validation de location
  openValidationModal = (rental, isMarkAsDelivered = false, isMarkAsReadyToDeliver = false, isSetToPreparation = false) => {
    if (isMarkAsDelivered) {
      // Si c'est un marquage comme livré, on ouvre la modal de confirmation
      this.setState({
        showDeliveryConfirmModal: true,
        selectedRentalForDelivery: rental,
        deliveryConfirmLoading: false,
      });
    } else if (isMarkAsReadyToDeliver) {
      // Si c'est un marquage comme "à livrer" (depuis EN_PREPARATION)
      this.setState({
        showReadyToDeliverModal: true,
        selectedRentalForReadyToDeliver: rental,
        readyToDeliverLoading: false,
      });
    } else if (isSetToPreparation) {
      // Si c'est un passage en préparation (depuis EN_ATTENTE) - simple confirmation
      this.setState({
        showSetToPreparationModal: true,
        selectedRentalForPreparation: rental,
        setToPreparationLoading: false,
      });
    } else {
      this.setState({
        showValidationModal: true,
        selectedRentalForValidation: rental,
        selectedEquipment: null,
        selectedEquipmentOption: null,
        selectedEquipmentState: "",
        selectedMaterialType: "",
        selectedBrand: "",
        selectedModel: "",
        validationLoading: false,
        validationRefInterne: rental.ref_interne || "",
        equipmentSearchResults: [],
        isSearchingEquipments: false,
        confirmReassignment: false,
        disinfectionDate: "",
      });
    }
  };

  // Fermer le modal de confirmation de livraison
  closeDeliveryConfirmModal = () => {
    this.setState({
      showDeliveryConfirmModal: false,
      selectedRentalForDelivery: null,
      deliveryConfirmLoading: false,
    });
  };

  // Confirmer la livraison (passer à ACTIF)
  confirmDelivery = async () => {
    const rental = this.state.selectedRentalForDelivery;
    if (!rental) return;

    const RentalStatus = require("../../enums/RentalStatus").default;
    this.setState({ deliveryConfirmLoading: true });

    try {
      await this.props.onUpdateRentalStatus(rental._id, RentalStatus.ACTIF);
      this.showSuccessNotification("Location marquée comme livrée avec succès !");
      this.closeDeliveryConfirmModal();
      this.fetchRentalsBasedOnRole();
    } catch (error) {
      this.setState({ deliveryConfirmLoading: false });
      this.showErrorNotification(
        error.message || "Erreur lors du marquage de la location comme livrée",
      );
    }
  };

  // Ouvrir le modal de confirmation de récupération
  openRecoveryConfirmModal = (rental) => {
    this.setState({
      showRecoveryConfirmModal: true,
      selectedRentalForRecovery: rental,
      recoveryConfirmLoading: false,
    });
  };

  // Fermer le modal de confirmation de récupération
  closeRecoveryConfirmModal = () => {
    this.setState({
      showRecoveryConfirmModal: false,
      selectedRentalForRecovery: null,
      recoveryConfirmLoading: false,
    });
  };

  // Confirmer la récupération (passer à TERMINE)
  confirmRecovery = async () => {
    const rental = this.state.selectedRentalForRecovery;
    if (!rental) return;

    const RentalStatus = require("../../enums/RentalStatus").default;
    this.setState({ recoveryConfirmLoading: true });

    try {
      await this.props.onUpdateRentalStatus(rental._id, RentalStatus.TERMINE);
      this.showSuccessNotification("Equipement marque comme recupere avec succes !");
      this.closeRecoveryConfirmModal();
      this.fetchRentalsBasedOnRole();
    } catch (error) {
      this.setState({ recoveryConfirmLoading: false });
      this.showErrorNotification(
        error.message || "Erreur lors du marquage de l'equipement comme recupere",
      );
    }
  };

  // Fermer le modal de confirmation "à livrer"
  closeReadyToDeliverModal = () => {
    this.setState({
      showReadyToDeliverModal: false,
      selectedRentalForReadyToDeliver: null,
      readyToDeliverLoading: false,
    });
  };

  // Confirmer le passage à "à livrer" (depuis EN_PREPARATION)
  confirmReadyToDeliver = async () => {
    const rental = this.state.selectedRentalForReadyToDeliver;
    if (!rental) return;

    const RentalStatus = require("../../enums/RentalStatus").default;
    this.setState({ readyToDeliverLoading: true });

    try {
      await this.props.onUpdateRentalStatus(rental._id, RentalStatus.A_LIVRER);
      this.showSuccessNotification("Location marquée à livrer avec succès !");
      this.closeReadyToDeliverModal();
      this.fetchRentalsBasedOnRole();
    } catch (error) {
      this.setState({ readyToDeliverLoading: false });
      this.showErrorNotification(
        error.message || "Erreur lors du passage à livrer",
      );
    }
  };

  // Fermer le modal de confirmation "en préparation"
  closeSetToPreparationModal = () => {
    this.setState({
      showSetToPreparationModal: false,
      selectedRentalForPreparation: null,
      setToPreparationLoading: false,
    });
  };

  // Confirmer le passage en préparation (depuis EN_ATTENTE)
  confirmSetToPreparation = async () => {
    const rental = this.state.selectedRentalForPreparation;
    if (!rental) return;

    const RentalStatus = require("../../enums/RentalStatus").default;
    this.setState({ setToPreparationLoading: true });

    try {
      await this.props.onUpdateRentalStatus(rental._id, RentalStatus.EN_PREPARATION);
      this.showSuccessNotification("Location passée en préparation avec succès !");
      this.closeSetToPreparationModal();
      this.fetchRentalsBasedOnRole();
    } catch (error) {
      this.setState({ setToPreparationLoading: false });
      this.showErrorNotification(
        error.message || "Erreur lors du passage en préparation",
      );
    }
  };

  // Ouvrir le modal de modification du résident
  openResidentModal = (rental) => {
    this.setState({
      showResidentModal: true,
      selectedRentalForResident: rental,
      residentModalLoading: false,
    });
  };

  // Fermer le modal de modification du résident
  closeResidentModal = () => {
    this.setState({
      showResidentModal: false,
      selectedRentalForResident: null,
      residentModalLoading: false,
    });
  };

  // Confirmer la modification du résident
  confirmResidentChange = async (residentData) => {
    const rental = this.state.selectedRentalForResident;
    if (!rental) return;

    this.setState({ residentModalLoading: true });

    try {
      await this.props.onUpdateRentalResident(rental._id, residentData);
      this.showSuccessNotification("Résident mis à jour avec succès !");
      this.closeResidentModal();
      this.fetchRentalsBasedOnRole();
    } catch (error) {
      this.setState({ residentModalLoading: false });
      this.showErrorNotification(
        error.message || "Erreur lors de la mise à jour du résident",
      );
    }
  };

  // Ajouter un nouveau résident depuis le modal
  handleAddResidentFromModal = (residentData, successCallback) => {
    const addResidentAction =
      this.props.user.role === Roles.ADMIN || this.props.user.role === Roles.SALES_REP
        ? this.props.onAddResidentAdmin
        : this.props.onAddResident;

    addResidentAction(residentData, () => {
      // Récupérer les résidents mis à jour
      this.fetchResidentsBasedOnRole().then(() => {
        // Trouver le résident nouvellement créé
        const newResident = this.props.residents.find(
          r => r.name === residentData.name && r.first_name === residentData.first_name
        );
        if (successCallback && newResident) {
          successCallback(newResident);
        }
      });
    });
  };

  // Ouvrir le modal de modification de la référence interne
  openInternalRefModal = (rental) => {
    this.setState({
      showInternalRefModal: true,
      selectedRentalForInternalRef: rental,
      internalRefModalLoading: false,
    });
  };

  // Fermer le modal de modification de la référence interne
  closeInternalRefModal = () => {
    this.setState({
      showInternalRefModal: false,
      selectedRentalForInternalRef: null,
      internalRefModalLoading: false,
    });
  };

  // Confirmer la modification de la référence interne
  confirmInternalRefChange = async (refInterne) => {
    const rental = this.state.selectedRentalForInternalRef;
    if (!rental) return;

    this.setState({ internalRefModalLoading: true });

    try {
      await this.props.onUpdateRentalInternalRef(rental._id, refInterne);
      this.showSuccessNotification("Reference interne mise a jour avec succes !");
      this.closeInternalRefModal();
      this.fetchRentalsBasedOnRole();
    } catch (error) {
      this.setState({ internalRefModalLoading: false });
      this.showErrorNotification(
        error.message || "Erreur lors de la mise a jour de la reference interne",
      );
    }
  };

  // Ouvrir le modal de modification du prix journalier
  openPriceModal = (rental) => {
    this.setState({
      showPriceModal: true,
      selectedRentalForPrice: rental,
      priceModalLoading: false,
    });
  };

  // Fermer le modal de modification du prix journalier
  closePriceModal = () => {
    this.setState({
      showPriceModal: false,
      selectedRentalForPrice: null,
      priceModalLoading: false,
    });
  };

  // Confirmer la modification du prix journalier
  confirmPriceChange = async (dailyPrice) => {
    const rental = this.state.selectedRentalForPrice;
    if (!rental) return;

    this.setState({ priceModalLoading: true });

    const endpoint = `${APIUrl.rootUrl}/rental/${rental._id}/update-price`;
    const token = APIUrl.jwtToken || sessionStorage.getItem("jwtToken");

    try {
      const response = await fetch(endpoint, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          jwtToken: token,
        },
        body: JSON.stringify({ daily_price: dailyPrice }),
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || "Erreur lors de la mise a jour du prix");
      }

      this.showSuccessNotification("Prix journalier mis a jour avec succes !");
      this.closePriceModal();
      this.fetchRentalsBasedOnRole();
    } catch (error) {
      this.setState({ priceModalLoading: false });
      this.showErrorNotification(
        error.message || "Erreur lors de la mise a jour du prix journalier",
      );
    }
  };

  closeValidationModal = () => {
    this.setState({
      showValidationModal: false,
      selectedRentalForValidation: null,
      selectedEquipment: null,
      selectedEquipmentOption: null,
      selectedEquipmentState: "",
      selectedMaterialType: "",
      selectedBrand: "",
      selectedModel: "",
      validationLoading: false,
      validationRefInterne: "",
      equipmentSearchResults: [],
      isSearchingEquipments: false,
      confirmReassignment: false,
      disinfectionDate: "",
    });
  };

  handleEquipmentStateChange = (e) => {
    this.setState({
      selectedEquipmentState: e.target.value,
    });
  };

  handleMaterialTypeChange = (materialTypeId) => {
    this.setState({
      selectedMaterialType: materialTypeId,
    });
  };

  handleCreateMaterialType = (data, successCallback) => {
    this.props.onAddMaterialsType(data, (newMaterialType) => {
      successCallback(newMaterialType);
    });
  };

  handleBrandChange = (brandId) => {
    this.setState({
      selectedBrand: brandId,
      selectedModel: "", // Reset model when brand changes
    });
  };

  handleModelChange = (modelId) => {
    this.setState({
      selectedModel: modelId,
    });
  };

  handleCreateBrand = (data, successCallback) => {
    this.props.onAddBrand(data, (newBrand) => {
      successCallback(newBrand);
    });
  };

  handleCreateModel = (data, successCallback) => {
    // Ajouter brand_id au modèle
    const modelData = {
      ...data,
      brand_id: this.state.selectedBrand,
    };
    this.props.onAddModel(modelData, (newModel) => {
      successCallback(newModel);
    });
  };

  handleValidationRefInterneChange = (inputValue, actionMeta) => {
    // react-select appelle onInputChange pour différentes actions
    // On ne veut rechercher que quand l'utilisateur tape (action = "input-change")
    const searchTerm = inputValue || "";

    // Si l'utilisateur clique sur "Créer", on crée une option temporaire pour l'affichage
    if (actionMeta && actionMeta.action === "create-option") {
      const newOption = {
        value: searchTerm,
        label: searchTerm,
        data: null,
      };
      this.setState({
        selectedEquipment: null,
        selectedEquipmentOption: newOption,
        equipmentSearchResults: [newOption],
        validationRefInterne: searchTerm,
      });
      return;
    }

    // Ne mettre à jour validationRefInterne que si c'est une vraie saisie utilisateur
    // Évite d'écraser la valeur quand on sélectionne un équipement (action: "set-value")
    if (!actionMeta || actionMeta.action === "input-change") {
      this.setState({
        validationRefInterne: searchTerm,
      });

      if (searchTerm.trim() !== "") {
        this.setState({ isSearchingEquipments: true });

        this.props
          .onSearchEquipmentsByRef(searchTerm)
          .then((equipments) => {
            this.setState({
              equipmentSearchResults: equipments || [],
              isSearchingEquipments: false,
            });
          })
          .catch(() => {
            this.setState({
              equipmentSearchResults: [],
              isSearchingEquipments: false,
            });
          });
      } else {
        this.setState({
          equipmentSearchResults: [],
          isSearchingEquipments: false,
          selectedEquipment: null,
        });
      }
    }
  };

  handleRefInterneSelect = (equipment) => {
    if (equipment) {
      // Garder l'équipement sélectionné dans les résultats pour que le ComboBox puisse l'afficher
      const selectedOption = {
        value: equipment._id,
        label: `${equipment.internal_ref}${
          equipment.establishment?.name
            ? ` - ${equipment.establishment.name}`
            : " - Libre"
        } (${equipment.brand?.name || ""} ${equipment.model?.name || ""})`,
        data: equipment,
      };

      this.setState({
        selectedEquipment: equipment,
        selectedEquipmentOption: selectedOption,
        validationRefInterne: equipment.internal_ref,
        equipmentSearchResults: [selectedOption],
        selectedBrand: "",
        selectedModel: "",
        confirmReassignment: false,
      });
    } else {
      this.setState({
        selectedEquipment: null,
        selectedEquipmentOption: null,
        validationRefInterne: "",
        selectedBrand: "",
        selectedModel: "",
        confirmReassignment: false,
        equipmentSearchResults: [],
      });
    }
  };

  handleConfirmReassignmentChange = (value) => {
    this.setState({ confirmReassignment: value });
  };

  handleDisinfectionDateChange = (value) => {
    this.setState({ disinfectionDate: value });
  };

  // Helper pour filtrer les modèles par marque
  getModelsByBrand = (brandId) => {
    const models = this.props.models || [];
    return models.filter((model) => model.brand_id === brandId);
  };

  // Styles personnalisés pour react-select

  confirmValidation = async () => {
    const {
      selectedRentalForValidation,
      selectedEquipment,
      selectedEquipmentState,
      selectedMaterialType,
      selectedBrand,
      selectedModel,
      validationRefInterne,
      confirmReassignment,
      disinfectionDate,
    } = this.state;

    if (!selectedRentalForValidation || !selectedRentalForValidation._id) {
      this.showErrorNotification("Erreur : location non sélectionnée");
      return;
    }

    // Validation de la référence interne
    if (!validationRefInterne || validationRefInterne.trim() === "") {
      this.showErrorNotification("Veuillez saisir une référence interne");
      return;
    }

    // Validation de l'état
    if (!selectedEquipmentState) {
      this.showErrorNotification("Veuillez sélectionner l'état du dispositif");
      return;
    }

    // Déterminer le scénario
    let scenario = null;
    if (selectedEquipment) {
      if (
        selectedEquipment.establishment_id &&
        selectedRentalForValidation.establishment &&
        selectedEquipment.establishment_id.toString() !==
          selectedRentalForValidation.establishment._id.toString()
      ) {
        scenario = "existing-assigned";
      } else {
        scenario = "existing-free";
      }
    } else {
      scenario = "new";
    }

    // Validation selon le scénario
    if (scenario === "existing-assigned" && !confirmReassignment) {
      this.showErrorNotification(
        "Veuillez confirmer la réassignation de l'équipement",
      );
      return;
    }

    // Validation de la date de désinfection pour équipement libre (non assigné)
    if (scenario === "existing-free" && !selectedEquipment.establishment_id && !disinfectionDate) {
      this.showErrorNotification(
        "Veuillez saisir la date de désinfection de l'équipement",
      );
      return;
    }

    if (scenario === "new" && (!selectedMaterialType || !selectedBrand || !selectedModel)) {
      this.showErrorNotification(
        "Veuillez sélectionner le type, la marque et le modèle pour le nouvel équipement",
      );
      return;
    }

    this.setState({ validationLoading: true });

    try {
      // Préparer le body selon le scénario
      const bodyData = {
        equipmentState: parseInt(selectedEquipmentState),
      };

      if (scenario === "existing-free" || scenario === "existing-assigned") {
        // SCENARIO A & B: Utiliser l'équipement existant
        bodyData.equipmentId = selectedEquipment._id;
        // Envoyer la référence interne pour mettre à jour la location
        bodyData.refInterne = validationRefInterne.trim();
        // Envoyer aussi le materialTypeId si disponible (pour compatibilité)
        if (selectedMaterialType) {
          bodyData.materialTypeId = selectedMaterialType;
        }
        // Envoyer la date de désinfection si l'équipement est libre (non assigné)
        if (scenario === "existing-free" && !selectedEquipment.establishment_id && disinfectionDate) {
          bodyData.disinfectionDate = disinfectionDate;
        }
      } else {
        // SCENARIO C: Créer un nouvel équipement
        bodyData.refInterne = validationRefInterne.trim();
        bodyData.brandId = selectedBrand;
        bodyData.modelId = selectedModel;
        bodyData.materialTypeId = selectedMaterialType;
      }

      // Call the validation endpoint
      const response = await fetch(
        APIUrl.rootUrl +
          "/rental/" +
          selectedRentalForValidation._id +
          "/validate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            jwtToken: sessionStorage.getItem("jwt"),
          },
          body: JSON.stringify(bodyData),
        },
      );

      const data = await response.json();

      if (response.ok) {
        let successMessage = "Location validée avec succès !";
        if (scenario === "new") {
          successMessage += " L'équipement a été ajouté au parc.";
        } else if (scenario === "existing-assigned") {
          successMessage += " L'équipement a été réassigné au client.";
        } else {
          successMessage += " L'équipement a été assigné à la location.";
        }

        this.showSuccessNotification(successMessage);
        this.closeValidationModal();
        this.fetchRentalsBasedOnRole();
      } else {
        throw new Error(
          data.error || "Erreur lors de la validation de la location",
        );
      }
    } catch (error) {
      this.showErrorNotification(
        error.message || "Erreur lors de la validation de la location",
      );
      this.setState({ validationLoading: false });
    }
  };

  // Méthodes pour le modal de prolongation de location
  openExtendModal = (rental) => {
    // Set the initial extend date to tomorrow
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const extendEndDate = tomorrow.toISOString().split("T")[0];

    this.setState({
      showExtendModal: true,
      selectedRentalForExtend: rental,
      extendEndDate: extendEndDate,
      extendLoading: false,
    });
  };

  closeExtendModal = () => {
    this.setState({
      showExtendModal: false,
      selectedRentalForExtend: null,
      extendEndDate: "",
      extendLoading: false,
    });
  };

  handleExtendEndDateChange = (e) => {
    this.setState({ extendEndDate: e.target.value });
  };

  confirmExtend = async () => {
    const { selectedRentalForExtend, extendEndDate } = this.state;

    if (!extendEndDate) {
      this.showErrorNotification(
        "Veuillez sélectionner une nouvelle date de fin",
      );
      return;
    }

    // Validate that the new end date is in the future
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const newEndDate = new Date(extendEndDate);
    if (newEndDate <= today) {
      this.showErrorNotification(
        "La nouvelle date de fin doit être dans le futur",
      );
      return;
    }

    this.setState({ extendLoading: true });

    try {
      const response = await fetch(
        APIUrl.rootUrl + "/rental/" + selectedRentalForExtend._id + "/extend",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            jwtToken: sessionStorage.getItem("jwt"),
          },
          body: JSON.stringify({
            endDate: extendEndDate,
          }),
        },
      );

      const data = await response.json();

      if (response.ok) {
        this.showSuccessNotification("Location prolongée avec succès !");
        this.closeExtendModal();
        this.fetchRentalsBasedOnRole();
      } else {
        throw new Error(
          data.error || "Erreur lors de la prolongation de la location",
        );
      }
    } catch (error) {
      this.showErrorNotification(
        "Erreur lors de la prolongation de la location",
      );
      this.setState({ extendLoading: false });
    }
  };

  // Méthodes pour le modal de terminaison de location
  openTerminateModal = (rental) => {
    this.setState({
      showTerminateModal: true,
      selectedRentalForTerminate: rental,
      terminateLoading: false,
    });
  };

  closeTerminateModal = () => {
    this.setState({
      showTerminateModal: false,
      selectedRentalForTerminate: null,
      terminateLoading: false,
    });
  };

  confirmTerminate = async () => {
    const { selectedRentalForTerminate } = this.state;

    this.setState({ terminateLoading: true });

    try {
      const response = await fetch(
        APIUrl.rootUrl +
          "/rental/" +
          selectedRentalForTerminate._id +
          "/terminate",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            jwtToken: sessionStorage.getItem("jwt"),
          },
          body: JSON.stringify({}),
        },
      );

      const data = await response.json();

      if (response.ok) {
        this.showSuccessNotification("Demande de récupération créée avec succès !");
        this.closeTerminateModal();
        this.fetchRentalsBasedOnRole();
      } else {
        throw new Error(
          data.error || "Erreur lors de la terminaison de la location",
        );
      }
    } catch (error) {
      this.showErrorNotification(
        "Erreur lors de la terminaison de la location",
      );
      this.setState({ terminateLoading: false });
    }
  };

  // Méthodes pour le modal de demande de fin de location (client uniquement)
  openRequestEndModal = (rental) => {
    this.setState({
      showRequestEndModal: true,
      selectedRentalForRequestEnd: rental,
      requestEndLoading: false,
    });
  };

  closeRequestEndModal = () => {
    this.setState({
      showRequestEndModal: false,
      selectedRentalForRequestEnd: null,
      requestEndLoading: false,
    });
  };

  confirmRequestEnd = async () => {
    const { selectedRentalForRequestEnd } = this.state;

    this.setState({ requestEndLoading: true });

    try {
      const response = await fetch(
        APIUrl.rootUrl + "/rental/" + selectedRentalForRequestEnd._id + "/request-end",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            jwtToken: sessionStorage.getItem("jwt") || APIUrl.jwtToken,
          },
          body: JSON.stringify({
            requested_end_date: new Date().toISOString(),
            comment: "",
          }),
        },
      );

      const data = await response.json();

      if (response.ok) {
        this.showSuccessNotification(
          "Votre demande de fin de location a été envoyée avec succès ! Elle sera traitée par un administrateur.",
        );
        this.closeRequestEndModal();
        this.fetchRentalsBasedOnRole();
      } else {
        throw new Error(
          data.error || "Erreur lors de l'envoi de la demande de fin de location",
        );
      }
    } catch (error) {
      this.showErrorNotification(
        error.message || "Erreur lors de l'envoi de la demande de fin de location",
      );
      this.setState({ requestEndLoading: false });
    }
  };

  // Méthode pour ouvrir le modal d'annulation de demande de fin (client uniquement)
  handleCancelEndRequest = (rental) => {
    this.setState({
      showCancelEndRequestModal: true,
      selectedRentalForCancelEnd: rental,
      cancelEndLoading: false,
    });
  };

  // Fermer le modal d'annulation de demande de fin
  closeCancelEndRequestModal = () => {
    this.setState({
      showCancelEndRequestModal: false,
      selectedRentalForCancelEnd: null,
      cancelEndLoading: false,
    });
  };

  // Confirmer l'annulation de la demande de fin
  confirmCancelEndRequest = async () => {
    const { selectedRentalForCancelEnd } = this.state;

    this.setState({ cancelEndLoading: true });

    try {
      const response = await fetch(
        APIUrl.rootUrl + "/rental/" + selectedRentalForCancelEnd._id + "/cancel-end-request",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            jwtToken: sessionStorage.getItem("jwt") || APIUrl.jwtToken,
          },
        },
      );

      const data = await response.json();

      if (response.ok) {
        this.showSuccessNotification(
          "Votre demande de fin de location a été annulée. La location est de nouveau active.",
        );
        this.closeCancelEndRequestModal();
        this.fetchRentalsBasedOnRole();
      } else {
        throw new Error(
          data.error || "Erreur lors de l'annulation de la demande de fin de location",
        );
      }
    } catch (error) {
      this.showErrorNotification(
        error.message || "Erreur lors de l'annulation de la demande de fin de location",
      );
      this.setState({ cancelEndLoading: false });
    }
  };

  // Méthodes pour le modal de synchronisation DM
  openSyncModal = () => {
    this.setState({
      showSyncModal: true,
      loadingDmList: true,
    });
    this.fetchDmList();
  };

  closeSyncModal = () => {
    this.setState({
      showSyncModal: false,
      dmList: [],
      loadingDmList: false,
      selectedDmIds: [],
      selectAllDm: false,
      establishmentFilter: "",
      dmSearchTerm: "",
      syncStep: 1,
      dmRentalData: {},
      globalStartDate: "",
      globalDailyPrice: "",
    });
  };

  handleDmSelect = (dmId) => {
    const { selectedDmIds } = this.state;
    if (selectedDmIds.includes(dmId)) {
      this.setState({
        selectedDmIds: selectedDmIds.filter((id) => id !== dmId),
        selectAllDm: false,
      });
    } else {
      const newSelectedIds = [...selectedDmIds, dmId];
      this.setState({
        selectedDmIds: newSelectedIds,
        selectAllDm: newSelectedIds.length === this.getFilteredDmList().length,
      });
    }
  };

  handleSelectAllDm = () => {
    const { selectAllDm } = this.state;
    const filteredDmList = this.getFilteredDmList();

    if (!selectAllDm) {
      this.setState({
        selectedDmIds: filteredDmList.map((dm) => dm._id),
        selectAllDm: true,
      });
    } else {
      this.setState({
        selectedDmIds: [],
        selectAllDm: false,
      });
    }
  };

  handleEstablishmentFilterChange = (event) => {
    this.setState({
      establishmentFilter: event.target.value,
    });
  };

  handleDmSearchChange = (event) => {
    this.setState({
      dmSearchTerm: event.target.value,
    });
  };

  getFilteredDmList = () => {
    const { dmList, establishmentFilter, dmSearchTerm } = this.state;
    const rentals = this.props.rentals?.rentals || [];

    return DmSyncHelper.getFilteredDmList(
      dmList,
      rentals,
      establishmentFilter,
      dmSearchTerm,
    );
  };

  getUniqueEstablishments = () => {
    return DmSyncHelper.getUniqueEstablishments(this.state.dmList);
  };

  goToNextStep = () => {
    const { selectedDmIds, dmRentalData, dmList } = this.state;

    // Initialiser les données de location pour les DM sélectionnés
    const newDmRentalData = { ...dmRentalData };
    selectedDmIds.forEach((dmId) => {
      if (!newDmRentalData[dmId]) {
        // Récupérer la date de début de location de la fiche équipement si elle existe
        const dm = dmList.find((d) => d._id === dmId);
        let prefilledStartDate = "";
        if (dm && dm.rentalStartDate) {
          // Formater la date en YYYY-MM-DD pour l'input date
          const date = new Date(dm.rentalStartDate);
          if (!isNaN(date.getTime())) {
            prefilledStartDate = date.toISOString().split("T")[0];
          }
        }

        newDmRentalData[dmId] = {
          startDate: prefilledStartDate,
          endDate: "",
          dailyPrice: "",
        };
      }
    });

    this.setState({
      syncStep: 2,
      dmRentalData: newDmRentalData,
    });
  };

  goToPreviousStep = () => {
    this.setState({
      syncStep: 1,
    });
  };

  handleDmRentalDataChange = (dmId, field, value) => {
    const { dmRentalData } = this.state;
    this.setState({
      dmRentalData: {
        ...dmRentalData,
        [dmId]: {
          ...dmRentalData[dmId],
          [field]: value,
        },
      },
    });
  };

  handleGlobalStartDateChange = (value) => {
    this.setState({ globalStartDate: value });
  };

  handleGlobalDailyPriceChange = (value) => {
    this.setState({ globalDailyPrice: value });
  };

  handleApplyGlobalValues = () => {
    const { selectedDmIds, dmRentalData, globalStartDate, globalDailyPrice } = this.state;

    const newDmRentalData = { ...dmRentalData };

    selectedDmIds.forEach((dmId) => {
      if (!newDmRentalData[dmId]) {
        newDmRentalData[dmId] = {
          startDate: "",
          endDate: "",
          dailyPrice: "",
        };
      }

      // Appliquer la date de début globale uniquement si le DM n'en a pas déjà une
      if (globalStartDate && !newDmRentalData[dmId].startDate) {
        newDmRentalData[dmId].startDate = globalStartDate;
      }

      // Appliquer le prix journalier global s'il est défini
      if (globalDailyPrice) {
        newDmRentalData[dmId].dailyPrice = globalDailyPrice;
      }
    });

    this.setState({ dmRentalData: newDmRentalData });
  };

  validateDmRentalData = () => {
    return DmSyncHelper.validateDmRentalData(
      this.state.selectedDmIds,
      this.state.dmRentalData,
    );
  };

  confirmDmSync = async () => {
    const { selectedDmIds, dmRentalData, dmList } = this.state;

    // Vérifier que toutes les données obligatoires sont remplies et valides
    for (const dmId of selectedDmIds) {
      const data = dmRentalData[dmId];
      if (!data.startDate || !data.dailyPrice) {
        NotificationManager.error(
          "Veuillez remplir la date de début et le prix journalier pour tous les DM sélectionnés",
        );
        return;
      }

      // Vérifier que la date de fin n'est pas antérieure à la date de début
      if (data.endDate && data.startDate && data.endDate < data.startDate) {
        NotificationManager.error(
          "La date de fin ne peut pas être antérieure à la date de début",
        );
        return;
      }
    }

    // Préparer les données pour l'API
    const dmRentalsForApi = DmSyncHelper.prepareDmRentalsForApi(
      selectedDmIds,
      dmList,
      dmRentalData,
    );

    try {
      await this.props.onCreateDmRentals(dmRentalsForApi);
      NotificationManager.success(
        `${selectedDmIds.length} location${selectedDmIds.length > 1 ? "s" : ""} DM créée${selectedDmIds.length > 1 ? "s" : ""} avec succès`,
      );
      this.closeSyncModal();
    } catch (error) {
      NotificationManager.error(
        "Erreur lors de la création des locations. Veuillez réessayer.",
      );
    }
  };

  fetchDmList = async () => {
    try {
      const dmList = await DmSyncHelper.fetchDmList();
      this.setState({
        dmList: dmList,
        loadingDmList: false,
      });
    } catch (error) {
      this.setState({
        dmList: [],
        loadingDmList: false,
      });
      this.showErrorNotification(
        "Erreur lors du chargement de la liste des DM",
      );
    }
  };

  // Open lightbox with image
  openLightbox = (imageUrl) => {
    this.setState({
      lightboxOpen: true,
      lightboxImage: imageUrl,
    });
  };

  // Close lightbox
  closeLightbox = () => {
    this.setState({
      lightboxOpen: false,
      lightboxImage: null,
    });
  };

  renderRentalsTab = () => {
    return (
      <RentalTabContent
        rentals={this.props.rentals.rentals}
        selectedMonth={this.state.selectedMonth}
        selectedYear={this.state.selectedYear}
        selectedStatus={this.state.selectedStatus}
        selectedEstablishment={this.state.selectedEstablishment}
        establishments={this.props.establishments}
        searchTerm={this.state.searchTerm}
        searchPlaceholder="Rechercher un produit ou une réf. interne..."
        userRole={this.props.user.role}
        expandedSections={this.state.expandedSections}
        openDropdowns={this.state.openDropdowns}
        dropdownDirections={this.state.dropdownDirections}
        onMonthChange={this.handleMonthChange}
        onYearChange={this.handleYearChange}
        onStatusChange={this.handleStatusChange}
        onEstablishmentChange={this.handleEstablishmentChange}
        onSearchChange={this.handleSearchChange}
        onSyncClick={this.openSyncModal}
        onToggleSection={this.toggleSection}
        onOpenLightbox={this.openLightbox}
        onToggleDropdown={this.toggleDropdown}
        onCloseAllDropdowns={this.closeAllDropdowns}
        onModifyRental={this.handleModifyRental}
        onOpenValidationModal={this.openValidationModal}
        onOpenDeleteModal={this.openDeleteModal}
        onOpenExtendModal={this.openExtendModal}
        onOpenTerminateModal={this.openTerminateModal}
        onOpenRecoveryModal={this.openRecoveryConfirmModal}
        onCancelEndRequest={this.handleCancelEndRequest}
        onOpenResidentModal={this.openResidentModal}
        onOpenInternalRefModal={this.openInternalRefModal}
        onOpenPriceModal={this.openPriceModal}
        formatPrice={this.formatPrice}
        formatStatus={this.formatStatus}
        calculateMonthlyPrice={this.calculateMonthlyPrice}
        calculateSectionTotal={this.calculateSectionTotal}
        filterRentalsByCategory={this.filterRentalsByCategory}
      />
    );
  };

  render() {
    const { activeTab } = this.state;
    const isAdmin =
      this.props.user.role === Roles.ADMIN ||
      this.props.user.role === Roles.SALES_REP;

    return (
      <div className="container-fluid rentals-container">
        {/* Tab Navigation - uniquement pour les clients */}
        {!isAdmin && (
          <div className="row mb-4">
            <div className="col-12">
              <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === "families" ? "active" : ""}`}
                    onClick={() => this.handleTabChange("families")}
                    type="button"
                  >
                    Familles de produits
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    className={`nav-link ${activeTab === "rentals" ? "active" : ""}`}
                    onClick={() => this.handleTabChange("rentals")}
                    type="button"
                  >
                    Produits en location
                  </button>
                </li>
              </ul>
            </div>
          </div>
        )}

        {/* Tab Content */}
        <div className="tab-content">
          {!isAdmin && (
            <div
              className={`tab-pane ${activeTab === "families" ? "active show" : ""}`}
            >
              {activeTab === "families" && (
                <RentalFamiliesTab
                  filteredFamilies={this.state.filteredFamilies}
                  searchTerm={this.state.searchTerm}
                  products={this.props.products}
                  onProductSelected={this.handleProductSelected}
                />
              )}
            </div>
          )}
          <div
            className={`tab-pane ${isAdmin || activeTab === "rentals" ? "active show" : ""}`}
          >
            {(isAdmin || activeTab === "rentals") && this.renderRentalsTab()}
          </div>
        </div>

        {/* Lightbox for product images */}
        {this.state.lightboxOpen && (
          <Lightbox
            mainSrc={this.state.lightboxImage}
            onCloseRequest={this.closeLightbox}
            imagePadding={50}
          />
        )}

        {/* Modals */}
        <RentalDateModal
          show={this.state.showDateModal}
          rental={this.state.selectedRental}
          startDate={this.state.selectedStartDate}
          endDate={this.state.selectedEndDate}
          isLoading={this.state.isLoading}
          onClose={this.closeDateModal}
          onStartDateChange={this.handleStartDateChange}
          onEndDateChange={this.handleEndDateChange}
          onConfirm={this.confirmDateAction}
        />

        <RentalDeleteModal
          show={this.state.showDeleteModal}
          rental={this.state.selectedRentalForDelete}
          deletionReason={this.state.deletionReason}
          isLoading={this.state.isLoading}
          onClose={this.closeDeleteModal}
          onReasonChange={this.handleDeletionReasonChange}
          onConfirm={this.confirmDeletion}
        />

        <RentalValidationModal
          show={this.state.showValidationModal}
          rental={this.state.selectedRentalForValidation}
          selectedEquipment={this.state.selectedEquipment}
          selectedEquipmentOption={this.state.selectedEquipmentOption}
          selectedEquipmentState={this.state.selectedEquipmentState}
          selectedMaterialType={this.state.selectedMaterialType}
          selectedBrand={this.state.selectedBrand}
          selectedModel={this.state.selectedModel}
          validationRefInterne={this.state.validationRefInterne}
          isLoading={this.state.validationLoading}
          materialsTypes={this.props.materialsTypes || []}
          brands={this.props.brands || []}
          equipmentSearchResults={this.state.equipmentSearchResults}
          isSearchingEquipments={this.state.isSearchingEquipments}
          confirmReassignment={this.state.confirmReassignment}
          disinfectionDate={this.state.disinfectionDate}
          onClose={this.closeValidationModal}
          onEquipmentStateChange={this.handleEquipmentStateChange}
          onMaterialTypeChange={this.handleMaterialTypeChange}
          onCreateMaterialType={this.handleCreateMaterialType}
          onBrandChange={this.handleBrandChange}
          onModelChange={this.handleModelChange}
          onCreateBrand={this.handleCreateBrand}
          onCreateModel={this.handleCreateModel}
          onRefInterneChange={this.handleValidationRefInterneChange}
          onRefInterneSelect={this.handleRefInterneSelect}
          onConfirmReassignmentChange={this.handleConfirmReassignmentChange}
          onDisinfectionDateChange={this.handleDisinfectionDateChange}
          onConfirm={this.confirmValidation}
          getModelsByBrand={this.getModelsByBrand}
        />

        <RentalExtendModal
          show={this.state.showExtendModal}
          rental={this.state.selectedRentalForExtend}
          extendEndDate={this.state.extendEndDate}
          isLoading={this.state.extendLoading}
          onClose={this.closeExtendModal}
          onEndDateChange={this.handleExtendEndDateChange}
          onConfirm={this.confirmExtend}
        />

        <RentalTerminateModal
          show={this.state.showTerminateModal}
          rental={this.state.selectedRentalForTerminate}
          isLoading={this.state.terminateLoading}
          onClose={this.closeTerminateModal}
          onConfirm={this.confirmTerminate}
        />

        <RentalRequestEndModal
          show={this.state.showRequestEndModal}
          rental={this.state.selectedRentalForRequestEnd}
          isLoading={this.state.requestEndLoading}
          onClose={this.closeRequestEndModal}
          onConfirm={this.confirmRequestEnd}
        />

        <RentalCancelEndRequestModal
          show={this.state.showCancelEndRequestModal}
          rental={this.state.selectedRentalForCancelEnd}
          isLoading={this.state.cancelEndLoading}
          onClose={this.closeCancelEndRequestModal}
          onConfirm={this.confirmCancelEndRequest}
        />

        <RentalDeliveryConfirmModal
          show={this.state.showDeliveryConfirmModal}
          rental={this.state.selectedRentalForDelivery}
          isLoading={this.state.deliveryConfirmLoading}
          onClose={this.closeDeliveryConfirmModal}
          onConfirm={this.confirmDelivery}
        />

        <RentalRecoveryConfirmModal
          show={this.state.showRecoveryConfirmModal}
          rental={this.state.selectedRentalForRecovery}
          isLoading={this.state.recoveryConfirmLoading}
          onClose={this.closeRecoveryConfirmModal}
          onConfirm={this.confirmRecovery}
        />

        <RentalReadyToDeliverModal
          show={this.state.showReadyToDeliverModal}
          rental={this.state.selectedRentalForReadyToDeliver}
          isLoading={this.state.readyToDeliverLoading}
          onClose={this.closeReadyToDeliverModal}
          onConfirm={this.confirmReadyToDeliver}
        />

        <RentalSetToPreparationModal
          show={this.state.showSetToPreparationModal}
          rental={this.state.selectedRentalForPreparation}
          isLoading={this.state.setToPreparationLoading}
          onClose={this.closeSetToPreparationModal}
          onConfirm={this.confirmSetToPreparation}
        />

        <RentalResidentModal
          show={this.state.showResidentModal}
          rental={this.state.selectedRentalForResident}
          residents={this.props.residents}
          isLoading={this.state.residentModalLoading}
          onClose={this.closeResidentModal}
          onConfirm={this.confirmResidentChange}
          onAddResident={this.handleAddResidentFromModal}
        />

        <RentalInternalRefModal
          show={this.state.showInternalRefModal}
          rental={this.state.selectedRentalForInternalRef}
          isLoading={this.state.internalRefModalLoading}
          onClose={this.closeInternalRefModal}
          onConfirm={this.confirmInternalRefChange}
        />

        <RentalPriceModal
          show={this.state.showPriceModal}
          rental={this.state.selectedRentalForPrice}
          isLoading={this.state.priceModalLoading}
          onClose={this.closePriceModal}
          onConfirm={this.confirmPriceChange}
        />

        <RentalSyncModal
          show={this.state.showSyncModal}
          dmList={this.state.dmList}
          loadingDmList={this.state.loadingDmList}
          syncStep={this.state.syncStep}
          selectedDmIds={this.state.selectedDmIds}
          selectAllDm={this.state.selectAllDm}
          establishmentFilter={this.state.establishmentFilter}
          dmRentalData={this.state.dmRentalData}
          dmSearchTerm={this.state.dmSearchTerm}
          globalStartDate={this.state.globalStartDate}
          globalDailyPrice={this.state.globalDailyPrice}
          onClose={this.closeSyncModal}
          onEstablishmentFilterChange={this.handleEstablishmentFilterChange}
          onDmSearchChange={this.handleDmSearchChange}
          onSelectAllDm={this.handleSelectAllDm}
          onDmSelect={this.handleDmSelect}
          onDmRentalDataChange={this.handleDmRentalDataChange}
          onGlobalStartDateChange={this.handleGlobalStartDateChange}
          onGlobalDailyPriceChange={this.handleGlobalDailyPriceChange}
          onApplyGlobalValues={this.handleApplyGlobalValues}
          onGoToPreviousStep={this.goToPreviousStep}
          onGoToNextStep={this.goToNextStep}
          onConfirmDmSync={this.confirmDmSync}
          getFilteredDmList={this.getFilteredDmList}
          getUniqueEstablishments={this.getUniqueEstablishments}
          validateDmRentalData={this.validateDmRentalData}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  products: state.products,
  user: state.user,
  rentals: state.rentals,
  residents: state.residents,
  materialsTypes: state.materialsTypes,
  brands: state.brands,
  models: state.models,
  establishments: state.establishments,
});

const mapDispatchToProps = (dispatch) => ({
  onGetProducts: () => dispatch(getProducts()),
  onGetRentals: () => dispatch(getRentals()),
  onGetRentalsAdmin: () => dispatch(getRentalsAdmin()),
  onGetRentalsSales: () => dispatch(getRentalsSales()),
  onGetResidents: () => dispatch(getResidents()),
  onGetAllResidents: () => dispatch(getAllResidents()),
  onUpdateRentalStatus: (rentalId, newStatus) =>
    dispatch(updateRentalStatus(rentalId, newStatus)),
  onUpdateRentalResident: (rentalId, residentData) =>
    dispatch(updateRentalResident(rentalId, residentData)),
  onUpdateRentalInternalRef: (rentalId, refInterne) =>
    dispatch(updateRentalInternalRef(rentalId, refInterne)),
  onCreateDmRentals: (dmRentalsData) =>
    dispatch(createDmRentals(dmRentalsData)),
  onSearchEquipmentsByRef: (searchTerm) =>
    dispatch(searchEquipmentsByRef(searchTerm)),
  onAddMaterialsType: (data, successCallback) =>
    dispatch(addMaterialsType(data, successCallback)),
  onAddBrand: (data, successCallback) =>
    dispatch(addBrand(data, successCallback)),
  onAddModel: (data, successCallback) =>
    dispatch(addModel(data, successCallback)),
  onAddResident: (data, successCallback) =>
    dispatch(addResident(data, successCallback)),
  onAddResidentAdmin: (data, successCallback) =>
    dispatch(addResidentAdmin(data, successCallback)),
  onGetEstablishments: () => dispatch(getEstablishments()),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(Rentals)),
);
